import { Tabs } from "@shopify/polaris"
import { useLayoutEffect, useState } from "react"
import { useHistory, useLocation } from "react-router"
import { matchRoutes } from "react-router-config"

import routes from "@/router"

export function Layout() {
  const MenuTabs = [
    {
      content: t("Dashboard"),
      id: "/",
    },
    {
      content: t("Returns"),
      id: "/return-management",
    },
    {
      content: t("ReturnPortal"),
      id: "/return-page",
    },
    {
      content: t("Settings"),
      id: "/settings",
    },
    {
      content: t("Protection"),
      id: "/free-return-service",
    },
    {
      content: t("Analytics"),
      id: "/analytics",
    },
    {
      content: t("Integration"),
      id: "/integration",
    },
    {
      content: t("Billing"),
      id: "/billing",
    },
    {
      content: t("Feedback"),
      id: "/feedback",
    },
    {
      content: t("ComponentsDemo"),
      id: "/demo-page",
    },
  ]
  const history = useHistory()
  const { pathname } = useLocation()
  const branch = matchRoutes(routes, pathname)
  const [layoutSelected, setLayoutSelected] = useState(0)
  const handleTabChange = (selected: number) => {
    setLayoutSelected(selected)
    history.push(MenuTabs[selected].id)
  }

  useLayoutEffect(() => {
    // 根据当前pathname查找对应的tab索引，并设置选中
    const matchedIndex = MenuTabs.findIndex((tab) => {
      if (tab.id === "/" && pathname !== "/") return false
      return pathname.startsWith(tab.id)
    })
    if (matchedIndex !== -1 && matchedIndex !== layoutSelected) {
      setLayoutSelected(matchedIndex)
    }
    // setLayoutSelected(branch[0].route.selected)

    // 跳转后，返回页面顶部
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <Tabs
      onSelect={handleTabChange}
      selected={layoutSelected}
      tabs={MenuTabs} // 后续控制ul的宽度实现居中
    />
  )
}
